import { Button, Input } from "@heroui/react";
import { AppFrame, MotionBoundary } from "@hallyulytics/ui";
import { Trans } from "@lingui/react/macro";
import { useLoaderData } from "react-router";
import type { homeLoader } from "../router";

export function HomePage() {
  const data = useLoaderData<typeof homeLoader>();
  return (
    <AppFrame application="enterprise director" locale={data.locale}>
      <main className="page">
        <MotionBoundary>
          <section className="hero">
            <div>
              <div className="eyebrow">Tenant routing</div>
              <h1>Enter your corporate tag.</h1>
              <p>
                The director resolves only active assignments and redirects exclusively to a
                provisioned, allowlisted shard. Unknown and disabled tags receive the same response.
              </p>
            </div>
            <form className="panel" method="post" action="/api/v1/shards/resolve">
              <label>
                Corporate tag
                <Input name="corporate_tag" autoComplete="organization" required maxLength={64} />
              </label>
              <Button type="submit" variant="primary">
                <Trans id="director.continue">Continue securely</Trans>
              </Button>
            </form>
          </section>
        </MotionBoundary>
      </main>
    </AppFrame>
  );
}
